import React from "react";
import { Link } from "react-router-dom";
import { TOMES, TomeMeta } from "./tomeData";
import { useSeo } from "../../hooks";
import "./Library.scss";

interface Props {
    tomeId: string;
    children: React.ReactNode;
}

const TomeReader: React.FC<Props> = ({ tomeId, children }) => {
    const currentIndex = TOMES.findIndex((t) => t.id === tomeId);
    const tome: TomeMeta | undefined = TOMES[currentIndex];
    const prevTome: TomeMeta | undefined = TOMES[currentIndex - 1];
    const nextTome: TomeMeta | undefined = TOMES[currentIndex + 1];

    useSeo({
        title: tome?.seo.title ?? "Brigobaen Library — Oberin",
        description: tome?.seo.description ?? "",
        canonical: tome?.seo.canonical,
        robots: "index,follow",
        twitterCard: "summary",
    });

    return (
        <div className="tome-reader-wrapper">
            <div className="box-shadow">
                <div className="tome-reader-header">
                    <Link
                        to="/library"
                        className="tome-back-btn"
                        aria-label="Return to library shelf"
                    >
                        ← Library
                    </Link>
                    <div className="tome-reader-title-block">
                        <h1 className="sr-only">
                            {tome?.title}
                            {tome?.subtitle ? ` — ${tome.subtitle}` : ""}
                        </h1>
                        <div className="tome-reader-title" aria-hidden="true">
                            {tome?.title}
                            {tome?.subtitle ? ` — ${tome.subtitle}` : ""}
                        </div>
                        {tome?.author && (
                            <div className="tome-reader-subtitle">
                                by {tome.author}
                            </div>
                        )}
                    </div>
                </div>

                <div className="tome-content">{children}</div>

                <div className="tome-nav-row">
                    {prevTome ? (
                        <Link
                            to={prevTome.path}
                            className="tome-nav-btn"
                            aria-label={`Previous tome: ${prevTome.title}`}
                        >
                            ← {prevTome.title}
                            {prevTome.subtitle ? ` — ${prevTome.subtitle}` : ""}
                        </Link>
                    ) : (
                        <span
                            className="tome-nav-btn disabled"
                            aria-hidden="true"
                        >
                            ← Previous
                        </span>
                    )}
                    <span className="tome-nav-center" aria-hidden="true">
                        ✦
                    </span>
                    {nextTome ? (
                        <Link
                            to={nextTome.path}
                            className="tome-nav-btn"
                            aria-label={`Next tome: ${nextTome.title}`}
                        >
                            {nextTome.title}
                            {nextTome.subtitle
                                ? ` — ${nextTome.subtitle}`
                                : ""}{" "}
                            →
                        </Link>
                    ) : (
                        <span
                            className="tome-nav-btn disabled"
                            aria-hidden="true"
                        >
                            Next →
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TomeReader;
